import { get, put, post, destroy, upload } from 'utils/fetchRequest';

// ── File upload (CKEditor-аас) ──
export const uploadImage = async (data) => {
    try {
        return await upload('files/news', data);
    } catch (err) {
        return { error: err };
    }
};

// ── Admin: paginated жагсаалт ──
export const getNewsList = async (searchText, page, pageLimit, type) => {
    try {
        const params = new URLSearchParams();
        if (searchText) params.set('search', searchText);
        if (page) params.set('page', page);
        if (pageLimit) params.set('limit', pageLimit);
        if (type) params.set('type', type);
        const qs = params.toString();
        return await get(`news${qs ? `?${qs}` : ''}`);
    } catch (err) {
        return { error: err };
    }
};

// ── Public: сүүлийн N мэдээ (type filter) ──
//   getNewsClient(6, 'news')   — Цаг үеийн мэдээ
//   getNewsClient(6, 'press')  — Хэвлэлийн мэдээ
export const getNewsClient = async (limit = 5, type) => {
    try {
        const params = new URLSearchParams();
        params.set('limit', limit);
        if (type) params.set('type', type);
        return await get(`news/client?${params.toString()}`);
    } catch (err) {
        return { error: err };
    }
};

// ── Дэлгэрэнгүй ──
export const getNewsContent = async (newsId) => {
    try {
        return await get(`news/${newsId}`);
    } catch (err) {
        return { error: err };
    }
};

export const setNewsSeen = async (newsId) => {
    try {
        return await put(`news/seen/${newsId}`);
    } catch (err) {
        return { error: err };
    }
};

// ── Admin CRUD ──
export const createNews = async (data) => {
    try {
        return await post('news', data);
    } catch (err) {
        return { error: err };
    }
};

export const updateNews = async (id, data) => {
    try {
        return await put(`news/${id}`, data);
    } catch (err) {
        return { error: err };
    }
};

export const deleteNews = async (id) => {
    try {
        return await destroy(`news/${id}`);
    } catch (err) {
        return { error: err };
    }
};

export const setSpecial = async (id, data) => {
    try {
        return await put(`news/special/${id}`, data);
    } catch (err) {
        return { error: err };
    }
};
